import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "./atoms/Logo";
import Button from "./atoms/Button";

const LINKS = [
  { to: "/#features",  label: "Features"   },
  { to: "/#levels",    label: "Curriculum" },
  { to: "/pricing",    label: "Pricing"    },
  { to: "/api-docs",   label: "API"        },
];

export default function MarketingNav({ dark = false }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  function handleNavClick(e, to) {
    const [path, hash] = to.split("#");
    if (!hash) return; // plain route — let Link handle it
    e.preventDefault();
    if (pathname === path) {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(path + "#" + hash);
    }
  }

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkColor = dark ? "rgba(251,246,232,0.65)" : "var(--fg-2)";
  const linkActive = dark ? "var(--paper)" : "var(--fg-1)";

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: dark ? "var(--ink-900)" : "var(--paper)",
        borderBottom: scrolled
          ? `1px solid ${dark ? "rgba(251,246,232,0.10)" : "var(--border-1)"}`
          : "1px solid transparent",
        transition: "border-color 240ms cubic-bezier(.2,.8,.2,1)",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" style={{ height: 64 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Logo dark={dark} />
        </Link>

        <nav className="hidden md:flex" style={{ gap: 32 }}>
          {LINKS.map((l) => {
            const isActive = pathname === l.to.split("#")[0] && l.to.startsWith("/");
            return (
              <a
                key={l.label}
                href={l.to}
                onClick={(e) => handleNavClick(e, l.to)}
                style={{
                  color: isActive ? linkActive : linkColor,
                  fontWeight: 500,
                  fontSize: 14,
                  textDecoration: "none",
                  transition: "color 150ms cubic-bezier(.2,.8,.2,1)",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = linkActive)}
                onMouseLeave={(e) => (e.currentTarget.style.color = isActive ? linkActive : linkColor)}
              >
                {l.label}
              </a>
            );
          })}
        </nav>

        <div className="flex items-center" style={{ gap: 8 }}>
          <Link to="/login" className="hidden sm:inline-flex">
            <Button
              variant="ghost"
              size="sm"
              style={dark ? { color: "var(--paper)", borderColor: "rgba(251,246,232,0.30)", background: "transparent" } : undefined}
            >
              Log in
            </Button>
          </Link>
          <Link to="/onboarding">
            <Button variant="primary" size="sm">Start free</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
